import React, { useState, useEffect, useRef } from "react";
import { 
    Card, Row, Col, Button, Badge, Table, Spinner, Alert, 
    Modal, Form, InputGroup, Tooltip, OverlayTrigger 
} from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import { formatCurrency, formatDate, formatNumber } from "../utils/formatters";
import { STATUT_FACTURE, MODE_REGLEMENT } from "../utils/constantes";

import logo from "../assets/img/logo.jpeg";

import './Factures.css';

export default function DetailFacture() {
    const navigate = useNavigate();
    const { id } = useParams();
    const printRef = useRef();
    
    const [facture, setFacture] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showPaiementModal, setShowPaiementModal] = useState(false);
    const [showAvoirModal, setShowAvoirModal] = useState(false);
    const [saving, setSaving] = useState(false);
    const [generatingPDF, setGeneratingPDF] = useState(false);
    const [societeInfos, setSocieteInfos] = useState(null);
const [logoBase64, setLogoBase64] = useState('');
    // États pour les taxes dynamiques
    const [taxes, setTaxes] = useState({
        tva_taux: 18,
        css_taux: 1,
        tva_active: true,
        css_active: true
    });
    
    // États pour les alertes
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    // État pour le paiement
    const [paiement, setPaiement] = useState({
        montant: '',
        mode_reglement: 'especes',
        reference: '',
        date_reglement: new Date().toISOString().split('T')[0]
    });

    // État pour l'avoir
    const [avoir, setAvoir] = useState({
        motif: '',
        lignes: []
    });

    useEffect(() => {
        fetchFacture();
        fetchTaxes();

        fetchSocieteInfos(); // AJOUTER
    loadLogoBase64(); 
    }, [id]);



    // Charger les infos société
const fetchSocieteInfos = async () => {
    try {
        const token = localStorage.getItem("token");
        const response = await fetch(
            'https://sawd.julesferry-ga.com/api/parametres.php?action=societe',
            { headers: { 'Authorization': `Bearer ${token}` } }
        );
        
        if (response.ok) {
            const result = await response.json();
            if (result.data) {
                setSocieteInfos(result.data);
            }
        }
    } catch (err) {
        console.error("Erreur chargement société", err);
    }
};

// Charger le logo en base64
// Modifiez la fonction loadLogoBase64

    // FONCTION POUR CHARGER LES TAXES
    const fetchTaxes = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                'https://sawd.julesferry-ga.com/api/parametres.php?action=taxes',
                { headers: { 'Authorization': `Bearer ${token}` } }
            );
            if (response.ok) {
                const result = await response.json();
                if (result.data) {
                    setTaxes(result.data);
                }
            }
        } catch (err) {
            console.error("Erreur chargement taxes", err);
        }
    };

    const fetchFacture = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const response = await fetch(
                `https://sawd.julesferry-ga.com/api/factures.php?id=${id}`,
                { headers: { 'Authorization': `Bearer ${token}` } }
            );

            if (!response.ok) throw new Error("Erreur chargement");
            
            const result = await response.json();
            setFacture(result.data);
            
            // Initialiser les lignes pour l'avoir
            if (result.data?.lignes) {
                setAvoir({
                    ...avoir,
                    lignes: result.data.lignes.map(l => ({
                        ...l,
                        selected: true,
                        quantite_avoir: l.quantite
                    }))
                });
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const showSuccess = (message) => {
        setSuccessMessage(message);
        setShowSuccessAlert(true);
        setTimeout(() => setShowSuccessAlert(false), 3000);
    };

    const showError = (message) => {
        setErrorMessage(message);
        setShowErrorAlert(true);
        setTimeout(() => setShowErrorAlert(false), 3000);
    };

    const handlePaiementSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);

        try {
            const userStr = localStorage.getItem("user");
            const user = userStr ? JSON.parse(userStr) : null;
            const id_utilisateur = user?.id || user?.id_utilisateur;

            const token = localStorage.getItem("token");
            const response = await fetch(
                'https://sawd.julesferry-ga.com/api/factures.php',
                {
                    method: 'POST',
                    headers: { 
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        action: 'encaisser',
                        id_facture: id,
                        montant: parseFloat(paiement.montant),
                        mode_reglement: paiement.mode_reglement,
                        reference: paiement.reference,
                        id_utilisateur: id_utilisateur
                    })
                }
            );

            const result = await response.json();

            if (result.success) {
                setShowPaiementModal(false);
                fetchFacture();
                showSuccess("Paiement enregistré avec succès");
            } else {
                showError(result.message || "Erreur lors du paiement");
            }
        } catch (err) {
            showError("Erreur de connexion");
        } finally {
            setSaving(false);
        }
    };

    const handleAvoirSubmit = async (e) => {
        e.preventDefault();
        
        const lignesSelectionnees = avoir.lignes.filter(l => l.selected);
        
        if (lignesSelectionnees.length === 0) {
            showError("Sélectionnez au moins une ligne pour l'avoir");
            return;
        }

        setSaving(true);

        try {
            const userStr = localStorage.getItem("user");
            const user = JSON.parse(userStr);
            const token = localStorage.getItem("token");

            const response = await fetch(
                'https://sawd.julesferry-ga.com/api/factures.php',
                {
                    method: 'POST',
                    headers: { 
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        action: 'avoir',
                        id_facture: id,
                        motif: avoir.motif,
                        lignes: lignesSelectionnees.map(l => ({
                            id_produit: l.id_produit,
                            quantite: l.quantite_avoir,
                            prix_unitaire_ht: l.prix_unitaire_ht,
                            tva_taux: l.tva_taux,
                            css_taux: l.css_taux
                        })),
                        id_utilisateur: user.id || user.id_utilisateur
                    })
                }
            );

            const result = await response.json();

            if (result.success) {
                setShowAvoirModal(false);
                fetchFacture();
                showSuccess("Avoir créé avec succès");
            } else {
                showError(result.message || "Erreur lors de la création de l'avoir");
            }
        } catch (err) {
            console.error(err);
            showError("Erreur de connexion");
        } finally {
            setSaving(false);
        }
    };

    // STYLES CSS POUR L'IMPRESSION
 // STYLES CSS POUR L'IMPRESSION - VERSION ÉPURÉE
const printStyles = `
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    body {
        background: #f5f7fa;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
        padding: 30px;
        color: #2c3e50;
    }

    .document-paper {
        max-width: 900px;
        margin: 0 auto;
        background: white;
        box-shadow: 0 5px 20px rgba(0,0,0,0.1);
        padding: 30px 35px;
        border-radius: 8px;
    }

    /* En-tête */
    .document-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 25px;
        padding-bottom: 20px;
        border-bottom: 2px solid #4361ee;
    }

    .company-info h1 {
        font-size: 1.8rem;
        font-weight: 700;
        color: #1e293b;
        margin-bottom: 5px;
    }

    .company-details {
        font-size: 0.85rem;
        color: #5a6a7e;
        line-height: 1.5;
        margin-top: 5px;
    }

    .company-details span {
        display: inline-block;
        margin-right: 20px;
    }

    .document-badge {
        text-align: right;
    }

    .document-badge .doc-type {
        font-size: 1.2rem;
        font-weight: 600;
        color: #4361ee;
        margin-bottom: 5px;
    }

    .document-badge .doc-number {
        font-size: 0.9rem;
        color: #5a6a7e;
        background: #f1f5f9;
        padding: 4px 12px;
        border-radius: 4px;
        display: inline-block;
    }

    .status-badge {
        display: inline-block;
        padding: 4px 12px;
        border-radius: 4px;
        font-size: 0.8rem;
        font-weight: 600;
        text-transform: uppercase;
        margin-top: 8px;
    }

    .status-badge.brouillon { background: #e2e8f0; color: #475569; }
    .status-badge.envoye { background: #dbeafe; color: #1e40af; }
    .status-badge.accepte { background: #d1fae5; color: #065f46; }
    .status-badge.refuse { background: #fee2e2; color: #991b1b; }
    .status-badge.payee { background: #d1fae5; color: #065f46; }
    .status-badge.impayee { background: #fee2e2; color: #991b1b; }

    /* Section client */
    .client-section {
        background: #f8fafc;
        padding: 0px;
        border-radius: 6px;
        margin: 0px 0;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }

    .client-info h3 {
        font-size: 0.8rem;
        font-weight: 600;
        color: #4361ee;
        text-transform: uppercase;
        letter-spacing: 0.3px;
        margin-bottom: 12px;
    }

    .client-name {
        font-size: 1.2rem;
        font-weight: 600;
        color: #1e293b;
        margin-bottom: 8px;
    }

    .client-details {
        font-size: 0.85rem;
        color: #4a5a6e;
        line-height: 1.6;
    }

    .client-details span {
        display: block;
    }

    .document-dates {
        text-align: right;
    }

    .date-item {
        margin-bottom: 8px;
    }

    .date-item .label {
        font-size: 0.75rem;
        color: #6f7d95;
        display: block;
    }

    .date-item .value {
        font-size: 1rem;
        font-weight: 500;
        color: #1e293b;
    }

    .date-item.expired .value {
        color: #dc2626;
    }

    .validity-badge {
        font-size: 0.8rem;
        padding: 4px 10px;
        background: #fef3c7;
        color: #92400e;
        border-radius: 4px;
        display: inline-block;
        margin-top: 5px;
    }

    .validity-badge.expired {
        background: #fee2e2;
        color: #991b1b;
    }

    /* Notes */
    .notes-section {
        background: #fef9e7;
        padding: 12px 15px;
        border-left: 3px solid #f59e0b;
        margin: 20px 0;
        font-size: 0.9rem;
        color: #4a5a6e;
    }

    .notes-section strong {
        color: #b45309;
        margin-right: 8px;
    }

    /* Tableau */
    .table-container {
        margin: 25px 0;
        border: 1px solid #e2e8f0;
        border-radius: 6px;
        overflow: hidden;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 0.85rem;
    }

    th {
        background: #f1f5f9;
        color: #1e293b;
        font-weight: 600;
        padding: 12px 10px;
        text-align: left;
        border-bottom: 1px solid #cbd5e1;
    }

    td {
        padding: 10px;
        border-bottom: 1px solid #e2e8f0;
    }

    tr:last-child td {
        border-bottom: none;
    }

    .ref-cell {
        font-family: 'Courier New', monospace;
        font-size: 0.8rem;
        color: #4361ee;
        background: #eef2ff;
        padding: 3px 8px;
        border-radius: 3px;
        display: inline-block;
    }

    .amount-cell {
        text-align: right;
        font-weight: 500;
    }

    .text-center {
        text-align: center;
    }

    /* Totaux */
    .totals-wrapper {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }

    .totals-card {
        width: 350px;
    }

    .total-line {
        display: flex;
        justify-content: space-between;
        padding: 8px 0;
        border-bottom: 1px dashed #d1d9e6;
    }

    .total-line:last-child {
        border-bottom: none;
    }

    .total-line .label {
        color: #4a5a6e;
    }

    .total-line .value {
        font-weight: 500;
    }

    .total-line.highlight {
        background: #f1f5f9;
        margin-top: 8px;
        padding: 12px;
        border-radius: 4px;
        font-weight: 600;
    }

    .total-line.highlight .label,
    .total-line.highlight .value {
        color: #4361ee;
        font-size: 1.1rem;
    }

    /* Pied de page */
    .document-footer {
        margin-top: 35px;
        padding-top: 15px;
        border-top: 1px solid #d1d9e6;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.75rem;
        color: #7f8c9f;
    }

    .legal-info span {
        margin-right: 20px;
    }

    .signature-area {
        text-align: right;
    }

    .signature-line {
        margin-top: 5px;
        font-style: italic;
    }

    @media print {
        body {
            background: white;
            padding: 0;
        }
        .document-paper {
            box-shadow: none;
            padding: 20px;
        }
        th {
            background: #f1f5f9 !important;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
        }
    }
`;
const getLogoUrl = () => {
    // Essayer différents chemins possibles
    const possiblePaths = [
        '../assets/img/logo.jpeg',
        '/assets/img/logo.jpeg',
        './assets/img/logo.jpeg',
        'assets/img/logo.jpeg'
    ];
    
    // Retourner le premier chemin qui fonctionne (ou le chemin par défaut)
    return possiblePaths[0];
};


// Modifiez la fonction loadLogoBase64 pour gérer les erreurs
const loadLogoBase64 = () => {
    return new Promise((resolve) => {
        try {
            const img = new Image();
            img.crossOrigin = "Anonymous";
            
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL('image/jpeg');
                setLogoBase64(dataURL);
                resolve(dataURL);
            };
            
            img.onerror = () => {
                console.warn("Impossible de charger le logo");
                setLogoBase64('');
                resolve('');
            };
            
            img.src = logo;
        } catch (error) {
            console.error("Erreur chargement logo:", error);
            setLogoBase64('');
            resolve('');
        }
    });
};




 const companie = {
        name: societeInfos?.nom || 'GESTION STOCK',
        address: societeInfos?.adresse || '123 Rue du Commerce, Libreville',
        phone: societeInfos?.telephone || '+241 01 23 45 67',
        email: societeInfos?.email || 'contact@gestionstock.ga',
        site_web: societeInfos?.site_web || 'www.gestionstock.ga',
        rc: societeInfos?.rc || 'LB/2025/00123',
        nif: societeInfos?.nif || '20251234567',
        patente: societeInfos?.patente || 'PAT0012345',
        logo_url: societeInfos?.logo_url 
    };

// Version alternative de genererHTMLImpression avec plus de fallbacks
const genererHTMLImpression = () => {
    if (!facture) return '';

    const company = {
        name: societeInfos?.nom || 'GESTION STOCK',
        address: societeInfos?.adresse || '123 Rue du Commerce, Libreville',
        phone: societeInfos?.telephone || '+241 01 23 45 67',
        email: societeInfos?.email || 'contact@gestionstock.ga',
        site_web: societeInfos?.site_web || 'www.gestionstock.ga',
        rc: societeInfos?.rc || 'LB/2025/00123',
        nif: societeInfos?.nif || '20251234567',
        patente: societeInfos?.patente || 'PAT0012345',
        logo_url: societeInfos?.logo_url 
    };

    // Configuration des statuts avec payee_partielle
    const statutConfig = {
        brouillon: { class: 'brouillon', label: 'BROUILLON' },
        envoye: { class: 'envoye', label: 'ENVOYÉ' },
        accepte: { class: 'accepte', label: 'ACCEPTÉ' },
        refuse: { class: 'refuse', label: 'REFUSÉ' },
        payee: { class: 'payee', label: 'PAYÉE' },
        impayee: { class: 'impayee', label: 'IMPAYÉE' },
        payee_partielle: { class: 'payee_partielle', label: 'PAIEMENT PARTIEL' }
    };

    const statut = statutConfig[facture.statut] || statutConfig.brouillon;
    const estExpire = new Date(facture.date_echeance) < new Date();
    const joursRestant = Math.ceil((new Date(facture.date_echeance) - new Date()) / (1000 * 60 * 60 * 24));
    
    // Calculs des montants
    const totalHT = facture.montant_ht || 0;
    const totalTVA = facture.montant_tva || 0;
    const totalCSS = facture.montant_css || 0;
    const totalTTC = facture.net_a_payer || 0;
    const montantRegle = facture.montant_regle || 0;
    const reste = totalTTC - montantRegle;

    const logoSrc = company.logo_url || ''; 
    const logoText = company.name.substring(0, 2).toUpperCase();

    return `
        <!DOCTYPE html>
        <html lang="fr">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Facture ${facture.numero_facture}</title>
            <style>
                ${printStyles}
                /* Ajout du style pour payee_partielle */
                .status-badge.payee_partielle { 
                    background: #fbbf24; 
                    color: #92400e; 
                }
                .logo {
                    width: 80px;
                    height: 80px;
                    object-fit: contain;
                }
                .logo-fallback {
                    width: 60px;
                    height: 60px;
                    background: linear-gradient(135deg, #4361ee, #3a56d4);
                    color: white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: bold;
                    font-size: 1.5rem;
                    border-radius: 8px;
                    box-shadow: 0 2px 10px rgba(67, 97, 238, 0.3);
                }
                /* Section des paiements */
                .paiements-section {
                    margin-top: 20px;
                    padding: 15px;
                    background: #f8fafc;
                    border-radius: 8px;
                }
                .paiement-item {
                    display: flex;
                    justify-content: space-between;
                    padding: 8px 0;
                    border-bottom: 1px dashed #e2e8f0;
                }
                .paiement-item:last-child {
                    border-bottom: none;
                }
                .montant-regle {
                    color: #10b981;
                    font-weight: 600;
                }
                .montant-reste {
                    color: #ef4444;
                    font-weight: 700;
                }
                .total-regle {
                    background: #d1fae5;
                    padding: 8px 12px;
                    border-radius: 6px;
                    margin-top: 10px;
                }
                .total-reste {
                    background: #fee2e2;
                    padding: 8px 12px;
                    border-radius: 6px;
                    margin-top: 10px;
                }
            </style>
        </head>
        <body>
            <div class="document-paper">
                <!-- En-tête avec logo -->
                <div class="document-header" style="display: flex; justify-content: space-between; align-items: flex-start;">
                    <div style="display: flex; align-items: center; gap: 15px;">
                        ${logoSrc ? `
                            <img src="${logoSrc}" alt="Logo ${company.name}" class="logo" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';">
                            <div class="logo-fallback" style="display: none;">${logoText}</div>
                        ` : `
                            <div class="logo-fallback">${logoText}</div>
                        `}
                        <div>
                            <h1 style="font-size: 1.8rem; font-weight: 700; color: #1e293b; margin: 0;">${company.name}</h1>
                            <div style="font-size: 0.8rem; color: #64748b;">${company.site_web}</div>
                        </div>
                    </div>
                    <div class="document-badge">
                        <div class="doc-type">FACTURE</div>
                        <div class="doc-number">N° ${facture.numero_facture}</div>
                        <div class="status-badge ${statut.class}">${statut.label}</div>
                    </div>
                </div>

                <!-- Coordonnées société -->
                <div style="font-size: 0.85rem; color: #5a6a7e; margin: 15px 0 20px 0; padding-bottom: 15px; border-bottom: 2px solid #4361ee;">
                    <span style="margin-right: 20px;">| ${company.address}</span>
                    <span style="margin-right: 20px;">| ${company.phone}</span>
                    <span style="margin-right: 20px;">| ✉ ${company.email}</span>
                </div>

                <!-- Client -->
                <div class="client-section"> 
                    <div class="client-info">
                        <h3>CLIENT</h3>
                        <div class="client-name">${facture.client_nom || 'Client non spécifié'}</div>
                        <div class="client-details">
                            <span>Code: ${facture.code_client || ''}</span>
                            ${facture.client_telephone ? `<span> ${facture.client_telephone}</span>` : ''}
                            ${facture.client_email ? `<span> ✉ ${facture.client_email}</span>` : ''}
                            ${facture.client_adresse ? `<span> ${facture.client_adresse}</span>` : ''}
                        </div>
                    </div>
                    <div class="document-dates">
                        <div class="date-item">
                            <span class="label">Date d'émission</span>
                            <span class="value">${formatDate(facture.date_facture)}</span>
                        </div>
                        <div class="date-item">
                            <span class="label">Date d'échéance</span>
                            <span class="value ${estExpire ? 'expired' : ''}">${formatDate(facture.date_echeance)}</span>
                        </div>
                        ${!estExpire ? `
                            <div class="validity-badge">
                                Échéance dans ${joursRestant} jours
                            </div>
                        ` : joursRestant < 0 ? `
                            <div class="validity-badge expired">
                                Expiré depuis ${Math.abs(joursRestant)} jours
                            </div>
                        ` : ''}
                    </div>
                </div>

                <!-- Notes -->
                

                <!-- Tableau des produits -->
                <div class="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th>Réf.</th>
                                <th>Désignation</th>
                                <th class="text-center">Qté</th>
                                <th class="amount-cell">Prix HT</th>
                                <th class="text-center">Remise</th>
                                <th class="amount-cell">Total HT</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${facture.lignes?.map(ligne => `
                                <tr>
                                    <td><span class="ref-cell">${ligne.reference || ''}</span></td>
                                    <td>${ligne.designation || ''}</td>
                                    <td class="text-center">${ligne.quantite || 0}</td>
                                    <td class="amount-cell">${formatCurrency(ligne.prix_unitaire_ht || 0)}</td>
                                    <td class="text-center">${ligne.remise ? `${ligne.remise}%` : '-'}</td>
                                    <td class="amount-cell">${formatCurrency(ligne.montant_ligne_ht || 0)}</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                </div>

                <!-- Totaux -->
                <div class="totals-wrapper">
                    <div class="totals-card">
                        <div class="total-line">
                            <span class="label">Total HT</span>
                            <span class="value">${formatCurrency(totalHT)}</span>
                        </div>
                        ${totalTVA > 0 ? `
                            <div class="total-line">
                                <span class="label">TVA (${taxes.tva_active ? taxes.tva_taux : 0}%)</span>
                                <span class="value">${formatCurrency(totalTVA)}</span>
                            </div>
                        ` : ''}
                        ${totalCSS > 0 ? `
                            <div class="total-line">
                                <span class="label">CSS (${taxes.css_active ? taxes.css_taux : 0}%)</span>
                                <span class="value">${formatCurrency(totalCSS)}</span>
                            </div>
                        ` : ''}
                        ${facture.remise_globale > 0 ? `
                            <div class="total-line">
                                <span class="label">Remise globale</span>
                                <span class="value">-${formatCurrency(facture.remise_globale)}</span>
                            </div>
                        ` : ''}
                        ${facture.avance_reglement > 0 ? `
                            <div class="total-line">
                                <span class="label">Avance / Acompte</span>
                                <span class="value">-${formatCurrency(facture.avance_reglement)}</span>
                            </div>
                        ` : ''}
                        <div class="total-line highlight">
                            <span class="label">TOTAL TTC</span>
                            <span class="value">${formatCurrency(totalTTC)}</span>
                        </div>
                        
                        <!-- Section montants réglés et reste -->
                        <div class="total-line" style="margin-top: 15px; border-top: 2px solid #4361ee; padding-top: 10px;">
                            <span class="label">Montant réglé</span>
                            <span class="value montant-regle">${formatCurrency(montantRegle)}</span>
                        </div>
                        <div class="total-line ${reste > 0 ? 'montant-reste' : ''}" style="font-weight: bold;">
                            <span class="label">Reste à payer</span>
                            <span class="value" style="color: ${reste > 0 ? '#ef4444' : '#10b981'}">${formatCurrency(reste)}</span>
                        </div>
                    </div>
                </div>

                <!-- Historique des paiements (si existant) -->
                ${facture.paiements && facture.paiements.length > 0 ? `
                    <div class="paiements-section">
                        <h3 style="color: #4361ee; margin-bottom: 15px; font-size: 1rem;">Historique des paiements</h3>
                        ${facture.paiements.map(p => `
                            <div class="paiement-item">
                                <div>
                                    <span style="font-weight: 500;">${formatDate(p.date_reglement)}</span>
                                    <span style="color: #64748b; margin-left: 10px;">${p.mode_reglement}</span>
                                    ${p.reference ? `<span style="color: #94a3b8; font-size: 0.8rem; margin-left: 10px;">Réf: ${p.reference}</span>` : ''}
                                </div>
                                <span class="montant-regle">${formatCurrency(p.montant)}</span>
                            </div>
                        `).join('')}
                        
                        <!-- Récapitulatif des paiements -->
                        <div class="${reste === 0 ? 'total-regle' : 'total-reste'}" style="display: flex; justify-content: space-between; margin-top: 15px;">
                            <span style="font-weight: 600;">${reste === 0 ? 'Total réglé' : 'Reste à payer'}</span>
                            <span style="font-weight: 700; ${reste === 0 ? 'color: #10b981' : 'color: #ef4444'}">
                                ${formatCurrency(reste === 0 ? montantRegle : reste)}
                            </span>
                        </div>
                    </div>
                ` : reste > 0 ? `
                    <!-- Si aucun paiement mais reste > 0 -->
                    <div class="total-reste" style="margin-top: 15px; padding: 10px; display: flex; justify-content: space-between;">
                        <span style="font-weight: 600;">Reste à payer</span>
                        <span style="font-weight: 700; color: #ef4444">${formatCurrency(reste)}</span>
                    </div>
                ` : ''}

                <!-- Pied de page -->
                <div class="document-footer">
                    <div class="legal-info">
                        <span>RC: ${company.rc}</span>
                        <span>NIF: ${company.nif}</span>
                        <span>Patente: ${company.patente}</span>
                    </div>
                    <div class="signature-area">
                        <div>Cachet et signature</div>
                        <div class="signature-line">____________________</div>
                    </div>
                </div>
            </div>
        </body>
        </html>
    `;
};



const handlePrint = async () => {
    // Générer le HTML
    const html = genererHTMLImpression();
    
    // Ouvrir la fenêtre
    const printWindow = window.open('', '_blank');
    printWindow.document.write(html);
    printWindow.document.close();
    
    // Attendre que toutes les images soient chargées
    await new Promise((resolve) => {
        const images = printWindow.document.images;
        const totalImages = images.length;
        let loadedImages = 0;
        
        if (totalImages === 0) {
            resolve();
            return;
        }
        
        Array.from(images).forEach(img => {
            if (img.complete) {
                loadedImages++;
                if (loadedImages === totalImages) resolve();
            } else {
                img.onload = () => {
                    loadedImages++;
                    if (loadedImages === totalImages) resolve();
                };
                img.onerror = () => {
                    loadedImages++;
                    if (loadedImages === totalImages) resolve();
                };
            }
        });
    });
    
    // Une fois toutes les images chargées, imprimer
    printWindow.focus();
    printWindow.print();
    showSuccess("Document ouvert pour impression");
};
// Fonction pour générer le HTML d'impression
// Fonction pour générer le HTML d'impression - VERSION DYNAMIQUE

    // Fonction d'impression
  

    // Fonction pour télécharger le PDF
    const generatePDF = () => {
        setGeneratingPDF(true);
        try {
            const html = genererHTMLImpression();
            const printWindow = window.open('', '_blank');
            printWindow.document.write(html);
            printWindow.document.close();
            printWindow.focus();
            printWindow.print();
            showSuccess("Document généré avec succès ✅");
        } catch (error) {
            console.error("Erreur PDF:", error);
            showError(`Erreur PDF: ${error.message}`);
        } finally {
            setGeneratingPDF(false);
        }
    };

    const getStatutBadge = (statut) => {
        const config = STATUT_FACTURE[statut] || STATUT_FACTURE.brouillon;
        return (
            <Badge 
                bg={config.color} 
                className="px-4 py-2 fs-6 statut-badge"
                style={{
                    background: `linear-gradient(135deg, var(--bs-${config.color}), var(--bs-${config.color}-dark))`,
                    border: 'none',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                }}
            >
                <i className={`${config.icon} me-2`}></i>
                {config.label}
            </Badge>
        );
    };

    const ActionButton = ({ variant, icon, onClick, tooltip, disabled = false, loading = false }) => (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-${variant}`}>{tooltip}</Tooltip>}
        >
            <Button
                variant={variant}
                onClick={onClick}
                disabled={disabled || loading}
                className="action-btn"
            >
                {loading ? <Spinner size="sm" /> : <i className={icon}></i>}
            </Button>
        </OverlayTrigger>
    );

    if (loading) {
        return (
            <>
                <Header />
                <div className="main main-app p-3 p-lg-4">
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
                            <p className="mt-3 text-muted">Chargement de la facture...</p>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    if (error || !facture) {
        return (
            <>
                <Header />
                <div className="main main-app p-3 p-lg-4">
                    <Alert variant="danger" className="text-center py-5">
                        <i className="ri-error-warning-line fs-48 mb-3 d-block"></i>
                        <h4>{error || "Facture non trouvée"}</h4>
                        <Button 
                            variant="outline-danger" 
                            className="mt-3"
                            onClick={() => navigate('/ventes/factures/liste')}
                        >
                            <i className="ri-arrow-left-line me-2"></i>
                            Retour aux factures
                        </Button>
                    </Alert>
                </div>
            </>
        );
    }

    const reste = facture.net_a_payer - (facture.montant_regle || 0);

    return (
        <>
            <Header />
            <div className="main main-app p-3 p-lg-4" id="facture-print" ref={printRef}>
                <div className="container-fluid">
                    {/* Alertes */}
                    {showSuccessAlert && (
                        <Alert variant="success" onClose={() => setShowSuccessAlert(false)} dismissible className="mb-4 alert-modern">
                            <i className="ri-checkbox-circle-line me-2 fs-5"></i>
                            {successMessage}
                        </Alert>
                    )}
                    
                    {showErrorAlert && (
                        <Alert variant="danger" onClose={() => setShowErrorAlert(false)} dismissible className="mb-4 alert-modern">
                            <i className="ri-error-warning-line me-2 fs-5"></i>
                            {errorMessage}
                        </Alert>
                    )}

                    {/* En-tête */}
                    <div className="page-header-modern mb-4 fade-in">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center gap-3">
                                <div className="page-icon">
                                    <i className="ri-file-list-3-line text-primary"></i>
                                </div>
                                <div>
                                    <h1 className="page-title mb-1">Détail de la facture</h1>
                                    <p className="page-subtitle mb-0">
                                        Consultez et gérez les informations de la facture
                                    </p>
                                </div>
                            </div>
                            <div className="d-flex gap-2 no-print">
                                <ActionButton
                                    variant="outline-secondary"
                                    icon="ri-arrow-left-line"
                                    onClick={() => navigate('/ventes/factures/liste')}
                                    tooltip="Retour à la liste"
                                />
                                <ActionButton
                                    variant="outline-primary"
                                    icon="ri-printer-line"
                                    onClick={handlePrint}
                                    tooltip="Imprimer"
                                />
                                <ActionButton
                                    variant="outline-danger"
                                    icon="ri-file-pdf-line"
                                    onClick={generatePDF}
                                    tooltip="Télécharger PDF"
                                    loading={generatingPDF}
                                    disabled={generatingPDF}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Carte d'identité de la facture */}
                    <Card className="border-0 shadow-sm mb-4 facture-identity-card">
                        <Card.Body>
                            <Row className="align-items-center">
                                <Col md={4} className="border-end">
                                    <div className="d-flex align-items-center">
                                        <div className="identity-icon bg-primary-soft">
                                            <i className="ri-barcode-line text-primary"></i>
                                        </div>
                                        <div className="ms-3">
                                            <small className="text-muted d-block">N° Facture</small>
                                            <h4 className="mb-0">{facture.numero_facture}</h4>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={3} className="border-end">
                                    <div className="d-flex align-items-center">
                                        <div className="identity-icon bg-success-soft">
                                            <i className="ri-calendar-line text-success"></i>
                                        </div>
                                        <div className="ms-3">
                                            <small className="text-muted d-block">Date</small>
                                            <h5 className="mb-0">{formatDate(facture.date_facture)}</h5>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={3} className="border-end">
                                    <div className="d-flex align-items-center">
                                        <div className="identity-icon bg-warning-soft">
                                            <i className="ri-time-line text-warning"></i>
                                        </div>
                                        <div className="ms-3">
                                            <small className="text-muted d-block">Échéance</small>
                                            <h5 className={`mb-0 ${new Date(facture.date_echeance) < new Date() ? 'text-danger' : ''}`}>
                                                {formatDate(facture.date_echeance)}
                                            </h5>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={2}>
                                    <div className="text-end">
                                        {getStatutBadge(facture.statut)}
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>

                    {/* Informations client et société */}
                    <Row className="g-4 mb-4">
                        <Col md={6}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Header className="bg-transparent border-0 pt-4">
                                    <div className="d-flex align-items-center">
                                        <div className="section-icon">
                                            <i className="ri-building-line text-primary"></i>
                                        </div>
                                        <h5 className="mb-0 ms-2">Informations société</h5>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <div className="company-info">
                                        <h4 className="fw-bold text-primary mb-3">GESTION STOCK</h4>
                                        <p className="mb-2">
                                            <i className="ri-map-pin-line text-muted me-2"></i>
                                            {companie.address}
                                        </p>
                                        <p className="mb-2">
                                            <i className="ri-phone-line text-muted me-2"></i>
                                            {companie.phone}
                                        </p>
                                        <p className="mb-2">
                                            <i className="ri-mail-line text-muted me-2"></i>
                                            {companie.email}
                                        </p>
                                        <p className="mb-0">
                                            <i className="ri-global-line text-muted me-2"></i>
                                            {companie.site_web}   
                                        </p>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Header className="bg-transparent border-0 pt-4">
                                    <div className="d-flex align-items-center">
                                        <div className="section-icon">
                                            <i className="ri-user-line text-primary"></i>
                                        </div>
                                        <h5 className="mb-0 ms-2">Informations client</h5>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <div className="client-info">
                                        <h4 className="fw-bold mb-3">{facture.client_nom}</h4>
                                        <p className="mb-2">
                                            <i className="ri-barcode-line text-muted me-2"></i>
                                            Code: {facture.code_client}
                                        </p>
                                        {facture.client_telephone && (
                                            <p className="mb-2">
                                                <i className="ri-phone-line text-muted me-2"></i>
                                                {facture.client_telephone}
                                            </p>
                                        )}
                                        {facture.client_email && (
                                            <p className="mb-2">
                                                <i className="ri-mail-line text-muted me-2"></i>
                                                {facture.client_email}
                                            </p>
                                        )}
                                        {facture.client_adresse && (
                                            <p className="mb-0">
                                                <i className="ri-map-pin-line text-muted me-2"></i>
                                                {facture.client_adresse}
                                            </p>
                                        )}
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* Lignes de facture */}
                    <Card className="border-0 shadow-sm mb-4">
                        <Card.Header className="bg-transparent border-0 pt-4">
                            <div className="d-flex align-items-center">
                                <div className="section-icon">
                                    <i className="ri-shopping-cart-line text-primary"></i>
                                </div>
                                <h5 className="mb-0 ms-2">Détail des produits</h5>
                            </div>
                        </Card.Header>
                        <Card.Body className="p-0">
                            <div className="table-responsive">
                                <Table className="mb-0 align-middle modern-table">
                                    <thead>
                                        <tr>
                                            <th>Référence</th>
                                            <th>Désignation</th>
                                            <th className="text-center">Quantité</th>
                                            <th className="text-end">Prix unitaire HT</th>
                                            <th className="text-center">Remise</th>
                                            <th className="text-end">Total HT</th>
                                            <th className="text-center">TVA</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {facture.lignes?.map((ligne, index) => (
                                            <tr key={index} className="product-row">
                                                <td>
                                                    <Badge bg="light" text="dark" className="font-mono px-3 py-2">
                                                        {ligne.reference}
                                                    </Badge>
                                                </td>
                                                <td className="fw-semibold">{ligne.designation}</td>
                                                <td className="text-center">{formatNumber(ligne.quantite)}</td>
                                                <td className="text-end">{formatCurrency(ligne.prix_unitaire_ht)}</td>
                                                <td className="text-center">{ligne.remise ? `${ligne.remise}%` : '-'}</td>
                                                <td className="text-end fw-bold text-primary">
                                                    {formatCurrency(ligne.montant_ligne_ht)}
                                                </td>
                                                <td className="text-center text-warning">
                                                    {taxes.tva_active ? (ligne.tva_taux || taxes.tva_taux) : 0}%
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </Card.Body>
                    </Card>

                    {/* Résumé et paiements AVEC TAXES DYNAMIQUES */}
                    <Row className="g-4 mb-4">
                        <Col md={6}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Header className="bg-transparent border-0 pt-4">
                                    <div className="d-flex align-items-center">
                                        <div className="section-icon">
                                            <i className="ri-calculator-line text-primary"></i>
                                        </div>
                                        <h5 className="mb-0 ms-2">Récapitulatif financier</h5>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <div className="recap-modern">
                                        <div className="recap-row">
                                            <span>Total HT</span>
                                            <span className="fw-bold">{formatCurrency(facture.montant_ht)}</span>
                                        </div>
                                        {taxes.tva_active && (
                                            <div className="recap-row">
                                                <span>TVA ({taxes.tva_taux}%)</span>
                                                <span className="fw-bold text-warning">{formatCurrency(facture.montant_tva)}</span>
                                            </div>
                                        )}
                                        {taxes.css_active && (
                                            <div className="recap-row">
                                                <span>CSS ({taxes.css_taux}%)</span>
                                                <span className="fw-bold text-info">{formatCurrency(facture.montant_css)}</span>
                                            </div>
                                        )}
                                        <div className="recap-divider"></div>
                                        <div className="recap-row highlight">
                                            <span>Total TTC</span>
                                            <span className="fw-bold text-primary fs-5">{formatCurrency(facture.net_a_payer)}</span>
                                        </div>
                                        
                                        {facture.remise_globale > 0 && (
                                            <div className="recap-row text-success">
                                                <span>Remise globale</span>
                                                <span className="fw-bold">-{formatCurrency(facture.remise_globale)}</span>
                                            </div>
                                        )}
                                        {facture.avance_reglement > 0 && (
                                            <div className="recap-row text-info">
                                                <span>Avance / Acompte</span>
                                                <span className="fw-bold">-{formatCurrency(facture.avance_reglement)}</span>
                                            </div>
                                        )}
                                        
                                        <div className="recap-divider"></div>
                                        <div className="recap-row total">
                                            <span className="h5">Net à payer</span>
                                            <span className={`h4 ${reste > 0 ? 'text-danger' : 'text-success'}`}>
                                                {formatCurrency(facture.net_a_payer)}
                                            </span>
                                        </div>
                                        <div className="recap-row">
                                            <span className="text-muted">Déjà réglé</span>
                                            <span className="fw-bold text-success">{formatCurrency(facture.montant_regle || 0)}</span>
                                        </div>
                                        <div className="recap-row final">
                                            <span className="h6">Reste à payer</span>
                                            <span className={`h5 ${reste > 0 ? 'text-danger' : 'text-success'}`}>
                                                {formatCurrency(reste)}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Actions */}
                                    <div className="d-grid gap-2 mt-4 no-print">
                                        {facture.statut !== 'payee' && facture.statut !== 'annulee' && (
                                            <Button 
                                                variant="success" 
                                                size="lg"
                                                className="btn-gradient-success"
                                                onClick={() => {
                                                    setPaiement({...paiement, montant: reste});
                                                    setShowPaiementModal(true);
                                                }}
                                                disabled={reste <= 0}
                                            >
                                                <i className="ri-bank-card-line me-2"></i>
                                                Encaisser
                                            </Button>
                                        )}
                                        {facture.statut !== 'annulee' && (
                                            <Button 
                                                variant="warning" 
                                                size="lg"
                                                className="btn-gradient-warning"
                                                onClick={() => setShowAvoirModal(true)}
                                            >
                                                <i className="ri-file-copy-line me-2"></i>
                                                Créer un avoir
                                            </Button>
                                        )}
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Historique des paiements */}
                        <Col md={6}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Header className="bg-transparent border-0 pt-4">
                                    <div className="d-flex align-items-center">
                                        <div className="section-icon">
                                            <i className="ri-history-line text-primary"></i>
                                        </div>
                                        <h5 className="mb-0 ms-2">Historique des paiements</h5>
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    {facture.paiements?.length > 0 ? (
                                        <div className="paiements-list">
                                            {facture.paiements.map((p, index) => {
                                                const mode = MODE_REGLEMENT.find(m => m.value === p.mode_reglement);
                                                return (
                                                    <div key={index} className="paiement-item">
                                                        <div className="d-flex justify-content-between align-items-start">
                                                            <div>
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <Badge bg="light" text="dark" className="px-3 py-2">
                                                                        <i className={`${mode?.icon || 'ri-bank-line'} me-2`}></i>
                                                                        {mode?.label || p.mode_reglement}
                                                                    </Badge>
                                                                    <small className="text-muted">{formatDate(p.date_reglement)}</small>
                                                                </div>
                                                                <small className="text-muted d-block mt-1">
                                                                    Réf: {p.numero_reglement}
                                                                </small>
                                                            </div>
                                                            <div className="text-end">
                                                                <span className="fw-bold text-success fs-5">
                                                                    {formatCurrency(p.montant)}
                                                                </span>
                                                                <br />
                                                                <Badge bg={p.statut === 'valide' ? 'success' : 'warning'}>
                                                                    {p.statut}
                                                                </Badge>
                                                            </div>
                                                        </div>
                                                        {p.reference && (
                                                            <small className="text-muted d-block mt-1">
                                                                <i className="ri-file-text-line me-1"></i>
                                                                {p.reference}
                                                            </small>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <div className="text-center py-5">
                                            <i className="ri-history-line fs-48 text-muted mb-3"></i>
                                            <p className="text-muted">Aucun paiement enregistré</p>
                                        </div>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* Notes */}
                    {facture.notes && (
                        <Card className="border-0 shadow-sm mb-4">
                            <Card.Header className="bg-transparent border-0 pt-4">
                                <div className="d-flex align-items-center">
                                    <div className="section-icon">
                                        <i className="ri-file-text-line text-primary"></i>
                                    </div>
                                    <h5 className="mb-0 ms-2">Notes</h5>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <p className="mb-0">{facture.notes}</p>
                            </Card.Body>
                        </Card>
                    )}
                </div>
                <Footer />
            </div>

            {/* Modal de paiement */}
            <Modal show={showPaiementModal} onHide={() => setShowPaiementModal(false)} centered className="modern-modal">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="ri-bank-card-line me-2 text-success"></i>
                        Enregistrer un paiement
                    </Modal.Title>
                </Modal.Header>
                <Form onSubmit={handlePaiementSubmit}>
                    <Modal.Body>
                        <Alert variant="info" className="mb-4 p-4">
    <Row className="align-items-center g-3">
        <Col md={8}>
            <div className="d-flex align-items-center">
                <div className="bg-primary bg-opacity-10 rounded-circle p-3 me-3">
                    <i className="ri-file-copy-line text-primary fs-4"></i>
                </div>
                <div>
                    <small className="text-muted text-uppercase fw-semibold">Facture</small>
                    <h5 className="mb-0 fw-bold">{facture?.numero_facture}</h5>
                </div>
            </div>
        </Col>
        <Col md={4}>
            <div className="text-md-end">
                <small className="text-muted d-block mb-2">Reste à payer</small>
                <span className="badge bg-danger text-white px-4 py-3 fs-5 rounded-3 shadow">
                    {formatCurrency(reste)}
                </span>
            </div>
        </Col>
    </Row>
</Alert>

                        <Form.Group className="mb-3">
                            <Form.Label>Date de paiement</Form.Label>
                            <Form.Control
                                type="date"
                                value={paiement.date_reglement}
                                onChange={(e) => setPaiement({...paiement, date_reglement: e.target.value})}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Montant</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    min="0.01"
                                    max={reste}
                                    value={paiement.montant}
                                    onChange={(e) => setPaiement({...paiement, montant: e.target.value})}
                                    required
                                />
                                <InputGroup.Text>FCFA</InputGroup.Text>
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Mode de règlement</Form.Label>
                            <Form.Select
                                value={paiement.mode_reglement}
                                onChange={(e) => setPaiement({...paiement, mode_reglement: e.target.value})}
                                required
                            >
                                {MODE_REGLEMENT.map(mode => (
                                    <option key={mode.value} value={mode.value}>
                                        {mode.label}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Référence (optionnel)</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="N° chèque, référence virement..."
                                value={paiement.reference}
                                onChange={(e) => setPaiement({...paiement, reference: e.target.value})}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowPaiementModal(false)}>
                            Annuler
                        </Button>
                        <Button variant="success" type="submit" disabled={saving}>
                            {saving ? (
                                <>
                                    <Spinner size="sm" className="me-2" />
                                    Enregistrement...
                                </>
                            ) : (
                                <>
                                    <i className="ri-check-line me-2"></i>
                                    Enregistrer le paiement
                                </>
                            )}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* Modal Avoir */}
            <Modal show={showAvoirModal} onHide={() => setShowAvoirModal(false)} size="lg" centered className="modern-modal">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <i className="ri-file-copy-line me-2 text-warning"></i>
                        Créer un avoir
                    </Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleAvoirSubmit}>
                    <Modal.Body>
                        <Alert variant="warning" className="mb-3">
                            <i className="ri-information-line me-2"></i>
                            L'avoir sera émis pour les lignes sélectionnées ci-dessous.
                        </Alert>

                        <Form.Group className="mb-3">
                            <Form.Label>Motif de l'avoir</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                value={avoir.motif}
                                onChange={(e) => setAvoir({...avoir, motif: e.target.value})}
                                placeholder="Raison de l'avoir (retour, annulation, erreur...)"
                                required
                            />
                        </Form.Group>

                        <h6 className="mb-3">Sélectionnez les lignes à avoir :</h6>
                        <div className="table-responsive">
                            <Table striped size="sm" className="modern-table">
                                <thead>
                                    <tr>
                                        <th width="50">
                                            <Form.Check
                                                type="checkbox"
                                                checked={avoir.lignes.every(l => l.selected)}
                                                onChange={(e) => {
                                                    const checked = e.target.checked;
                                                    setAvoir({
                                                        ...avoir,
                                                        lignes: avoir.lignes.map(l => ({
                                                            ...l,
                                                            selected: checked
                                                        }))
                                                    });
                                                }}
                                            />
                                        </th>
                                        <th>Produit</th>
                                        <th className="text-center">Quantité</th>
                                        <th className="text-end">Prix HT</th>
                                        <th className="text-end">Total HT</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {avoir.lignes.map((ligne, index) => (
                                        <tr key={index}>
                                            <td>
                                                <Form.Check
                                                    type="checkbox"
                                                    checked={ligne.selected}
                                                    onChange={(e) => {
                                                        const newLignes = [...avoir.lignes];
                                                        newLignes[index].selected = e.target.checked;
                                                        setAvoir({...avoir, lignes: newLignes});
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <div className="fw-semibold">{ligne.designation}</div>
                                                <small className="text-muted">{ligne.reference}</small>
                                            </td>
                                            <td className="text-center">
                                                <Form.Control
                                                    type="number"
                                                    min="1"
                                                    max={ligne.quantite}
                                                    size="sm"
                                                    style={{ width: '80px', margin: '0 auto' }}
                                                    value={ligne.quantite_avoir}
                                                    disabled={!ligne.selected}
                                                    onChange={(e) => {
                                                        const newLignes = [...avoir.lignes];
                                                        newLignes[index].quantite_avoir = parseInt(e.target.value) || 1;
                                                        setAvoir({...avoir, lignes: newLignes});
                                                    }}
                                                />
                                            </td>
                                            <td className="text-end">{formatCurrency(ligne.prix_unitaire_ht)}</td>
                                            <td className="text-end">
                                                {ligne.selected ? formatCurrency(ligne.prix_unitaire_ht * ligne.quantite_avoir) : '-'}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowAvoirModal(false)}>
                            Annuler
                        </Button>
                        <Button variant="warning" type="submit" disabled={saving}>
                            {saving ? (
                                <>
                                    <Spinner size="sm" className="me-2" />
                                    Création...
                                </>
                            ) : (
                                <>
                                    <i className="ri-check-line me-2"></i>
                                    Créer l'avoir
                                </>
                            )}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            <style>{`
                /* Styles pour l'impression */
                @media print {
                    .no-print {
                        display: none !important;
                    }
                    .main {
                        padding: 0 !important;
                    }
                    .card {
                        box-shadow: none !important;
                        border: 1px solid #dee2e6 !important;
                        break-inside: avoid;
                        page-break-inside: avoid;
                    }
                    .statut-badge {
                        background: #f8f9fa !important;
                        color: #000 !important;
                        border: 1px solid #dee2e6 !important;
                    }
                    .table {
                        font-size: 10px;
                    }
                }

                /* Animations */
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(-10px); }
                    to { opacity: 1; transform: translateY(0); }
                }

                .fade-in {
                    animation: fadeIn 0.5s ease-out;
                }

                /* En-tête moderne */
                .page-header-modern {
                    background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
                    padding: 1.5rem;
                    border-radius: 20px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
                }

                .page-icon {
                    width: 60px;
                    height: 60px;
                    background: linear-gradient(135deg, #4361ee20, #80b3ff20);
                    border-radius: 16px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 2rem;
                }

                .page-title {
                    font-size: 1.6rem;
                    font-weight: 700;
                    color: #1e293b;
                    margin: 0;
                }

                .page-subtitle {
                    color: #64748b;
                    font-size: 0.95rem;
                }

                /* Carte d'identité */
                .facture-identity-card {
                    border-radius: 16px !important;
                    background: white;
                }

                .identity-icon {
                    width: 50px;
                    height: 50px;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.5rem;
                }

                .bg-primary-soft { background: #4361ee20; }
                .bg-success-soft { background: #10b98120; }
                .bg-warning-soft { background: #f59e0b20; }

                /* Icônes de section */
                .section-icon {
                    width: 40px;
                    height: 40px;
                    background: linear-gradient(135deg, #4361ee20, #80b3ff20);
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.3rem;
                }

                /* Tableau moderne */
                .modern-table thead th {
                    background: #f8fafc;
                    color: #1e293b;
                    font-weight: 600;
                    font-size: 0.85rem;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    padding: 1rem;
                    border-bottom: 2px solid #e2e8f0;
                }

                .modern-table tbody td {
                    padding: 1rem;
                    vertical-align: middle;
                    border-bottom: 1px solid #e2e8f0;
                }

                .product-row {
                    transition: all 0.2s ease;
                }

                .product-row:hover {
                    background: #f8fafc;
                }

                /* Récapitulatif moderne */
                .recap-modern {
                    padding: 1rem;
                }

                .recap-row {
                    display: flex;
                    justify-content: space-between;
                    padding: 0.5rem 0;
                    border-bottom: 1px dashed #e2e8f0;
                }

                .recap-row:last-child {
                    border-bottom: none;
                }

                .recap-row.highlight {
                    background: #f8fafc;
                    padding: 0.75rem;
                    border-radius: 8px;
                    margin: 0.5rem 0;
                }

                .recap-divider {
                    height: 2px;
                    background: linear-gradient(90deg, #e2e8f0, transparent);
                    margin: 0.5rem 0;
                }

                .recap-row.total {
                    padding: 0.75rem 0;
                }

                .recap-row.final {
                    background: #4361ee10;
                    padding: 1rem;
                    border-radius: 12px;
                    margin-top: 0.5rem;
                }

                /* Liste des paiements */
                .paiements-list {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                }

                .paiement-item {
                    padding: 1rem;
                    background: #f8fafc;
                    border-radius: 12px;
                    transition: all 0.2s ease;
                }

                .paiement-item:hover {
                    transform: translateX(5px);
                    box-shadow: 0 4px 8px rgba(0,0,0,0.05);
                }

                /* Boutons d'action */
                .action-btn {
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.2s ease;
                    border: 1px solid #e2e8f0;
                    background: white;
                    color: #64748b;
                }

                .action-btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
                }

                .btn-gradient-success {
                    background: linear-gradient(135deg, #10b981, #059669);
                    border: none;
                    color: white;
                }

                .btn-gradient-success:hover {
                    background: linear-gradient(135deg, #059669, #047857);
                }

                .btn-gradient-warning {
                    background: linear-gradient(135deg, #f59e0b, #d97706);
                    border: none;
                    color: white;
                }

                .btn-gradient-warning:hover {
                    background: linear-gradient(135deg, #d97706, #b45309);
                }

                /* Alertes modernes */
                .alert-modern {
                    border: none;
                    border-radius: 12px;
                    padding: 1rem 1.5rem;
                    box-shadow: 0 4px 8px rgba(0,0,0,0.05);
                }

                /* Modals modernes */
                .modern-modal .modal-content {
                    border: none;
                    border-radius: 20px;
                    overflow: hidden;
                }

                .modern-modal .modal-header {
                    background: linear-gradient(135deg, #f8fafc, #ffffff);
                    border-bottom: 1px solid #e2e8f0;
                    padding: 1.5rem;
                }

                .modern-modal .modal-header .modal-title {
                    font-weight: 700;
                    color: #1e293b;
                }

                .modern-modal .modal-body {
                    padding: 1.5rem;
                }

                .modern-modal .modal-footer {
                    border-top: 1px solid #e2e8f0;
                    padding: 1.5rem;
                }

                /* Responsive */
                @media (max-width: 768px) {
                    .page-title {
                        font-size: 1.3rem;
                    }
                    .page-icon {
                        width: 50px;
                        height: 50px;
                        font-size: 1.5rem;
                    }
                    .identity-icon {
                        width: 40px;
                        height: 40px;
                        font-size: 1.2rem;
                    }
                }
            `}</style>
        </>
    );
}